<template>
  <div class="m-card-primary m-the-modal-content">
    <div>
      <header class="m-the-modal-header">
        <h5>{{ satelite.titulo }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>

      <!-- height-auto: la seccion normal tiene max-height y saca scroll -->
      <section
        key="modalSection"
        class="m-the-modal-section-height-auto m-satellites-modal"
      >
        <img
          v-if="satelite.imagen"
          class="m-satellites-modal-image"
          :alt="satelite.titulo"
          :src="satelite.imagen"
        >

        <p class="m-satellites-modal-state">
          <span
            :class="satelite.activo ? 'text-color-success' : 'text-color-danger'"
          >
            <i :class="[satelite.activo ? 'fas fa-check' : 'fas fa-ban', 'font-size-small']"></i>
            {{ satelite.activo
              ? $t('mEditionBillingSatellites.card.activo')
              : $t('mEditionBillingSatellites.card.inactivo') }}
          </span>
        </p>

        <h6 class="m-satellites-modal-subtitle">
          {{ $t('mEditionBillingSatellites.modalDetail.caracteristicas') }}
        </h6>

        <ul class="m-satellites-modal-limits">
          <li
            v-for="limite in limites"
            :key="limite.key"
          >
            <span>{{ limite.label }}</span>
            <b>{{ limite.value }}</b>
          </li>
        </ul>
      </section>

      <footer class="m-the-modal-footer m-satellites-modal-footer">
        <a
          href="#"
          class="m-satellites-modal-action"
          @click.prevent="toggleEstado"
        >
          <i :class="satelite.activo ? 'fas fa-ban' : 'fas fa-check'"></i>
          {{ satelite.activo
            ? $t('mEditionBillingSatellites.card.actions.desactivar')
            : $t('mEditionBillingSatellites.card.actions.activar') }}
        </a>

        <a
          href="#"
          class="m-satellites-modal-action text-color-danger"
          @click.prevent="eliminar"
        >
          <i class="far fa-trash-alt"></i>
          {{ $t('mEditionBillingSatellites.card.actions.eliminar') }}
        </a>

        <AtomButtonTheModalCancelAction
          :cancel-text="$t('mEditionBillingSatellites.modalDetail.close')"
        />
      </footer>
    </div>
  </div>
</template>

<script>
import { limitesDe } from '@/plugins/satelites/droops'

export default {
  name: 'MoleculeEditionBillingSatellitesModalDetail',

  data () {
    return {
      satelite: {},
      tab: 'juedroop'
    }
  },

  computed: {
    limites () {
      return limitesDe(this.tab)
        .filter(clave => this.satelite[clave] !== undefined && this.satelite[clave] !== null)
        .map(clave => ({
          key: clave,
          label: this.$t(`mEditionBillingSatellites.card.limites.${this.camelize(clave)}`),
          value: typeof this.satelite[clave] === 'boolean'
            ? (this.satelite[clave] ? 'Sí' : 'No')
            : this.satelite[clave]
        }))
    }
  },

  created () {
    this.satelite = this.$modal.element.satelite
    this.tab = this.$modal.element.tab
  },

  methods: {
    camelize (text) {
      return text.replace(/_([a-z])/g, (match, letra) => letra.toUpperCase())
    },

    eliminar () {
      this.$modal.showModal('MoleculeEditionBillingSatellitesModalDelete', {
        satelite: this.satelite,
        tab: this.tab
      })
    },

    toggleEstado () {
      this.$modal.element.nuevoEstado = !this.satelite.activo
      this.$modal.updateData('toggleEstadoSatelite')
    }
  }
}
</script>
